<template>
  <router-view />
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: 'App',
  methods: mapActions(['startRefreshScheduler']),
  beforeMount: function() {
    this.startRefreshScheduler();
  },
};

</script>


<style>
@import url("https://fonts.googleapis.com/css?family=Lato:400,700,900");

  html, body, .v-application {
    font-family: "Lato", "Roboto", sans-serif;
  }

  h1 {
    font-family: "Lato", "Roboto", sans-serif;
    font-size: 1.1em;
    font-weight: 900;
    line-height: 1.2em;
    margin: 0 auto;
  }
  h4 {
    font-family: "Lato", "Roboto", sans-serif;
    font-size: 16px;
    text-align: center;
  }
  button {
    min-height: 3.5em;
    padding: 15px 0 !important;
  }
  button span {
    font-family: "Lato", "Roboto", sans-serif;
    font-size: 1em;
    font-weight: 900;
    text-align: center;
  }
  p {
    font-family: "Lato", "Roboto", sans-serif;
    font-size: 1em;
    line-height: 1.4em;
    text-align: center;
  }
  input {
    font-family: "Lato", "Roboto", sans-serif;
    font-size: 1em;
    font-weight: 400;
  }
  label {
    font-family: "Lato", "Roboto", sans-serif;
    font-size: 0.65em;
    font-weight: 700;
  }
  .attention {
    background: #fff;
    padding: 15px 5px;
    border-radius: 6px;
    box-shadow: 0 1px 9px 0 rgba(0,0,0,0.11);
  }
  .queue-time-header {
    font-size: 0.9em;
    font-weight: 400;
    color: #9B9B9B !important;
  }
  .queue-time-value {
    font-size: 2em;
    font-weight: 900;
    margin: 8px 0;
    color: #00ADEE;
  }
  .v-messages__wrapper {
    text-align: center;
  }
  .margin-block {
    margin: 5px 0;
  }
  .narrow-content {
    max-width: 300px;
    margin: 0 auto;
  }

</style>